module.exports = __webpack_public_path__ + "img/hebrew-w.ccf5ae5c.svg";